import { type MutableRefObject, createContext, useContext } from 'react';

type CPPContext = {
  unreactiveNoteValue: MutableRefObject<string | undefined>;
};

const CPPContext = createContext<CPPContext>({
  unreactiveNoteValue: { current: undefined },
});

export const useCPPContext = () => useContext(CPPContext);

export default CPPContext;
